import type { CouponOnItemDeliveryEntity } from "./CouponOnItemDeliveryEntity";

export class CouponMiniEntity {
    id?: number;
    name?: string;
    redeemCode?: string;
    validFrom?: string;
    validTo?: string;
    createdAt?: string;
    isActive?: boolean;
    hidden?: boolean;
    onItem?: CouponOnItemDeliveryEntity;
    onDelivery?: CouponOnItemDeliveryEntity;
    imageUrl?: string | null;
}
